import { useState } from 'react';
import { ErroreApi } from '../api/cliente.js';
import { type Contatto, useSalvaContatto } from '../api/scheda.js';
import { CampoBc } from '../componenti/CampoBc.js';
import { Modale } from '../componenti/Modale.js';
import { t } from '../i18n/lingua.js';

/** Nome, cognome, ruolo e ufficio: le persone dentro un'anagrafica. */
export function ModaleContatto({
  identityId,
  contatto,
  limiti,
  onChiudi,
}: {
  identityId: number;
  contatto: Contatto | null;
  limiti: Record<string, number>;
  onChiudi: () => void;
}) {
  const [campi, setCampi] = useState({
    firstName: contatto?.firstName ?? '',
    lastName: contatto?.lastName ?? '',
    role: contatto?.role ?? '',
    officeName: contatto?.officeName ?? '',
  });

  const salva = useSalvaContatto(identityId);
  const errore = salva.error instanceof ErroreApi ? salva.error : null;
  const cambia = (chiave: keyof typeof campi) => (v: string) =>
    setCampi((c) => ({ ...c, [chiave]: v }));

  const invia = () =>
    salva.mutate(
      {
        ...(contatto ? { id: contatto.id } : {}),
        firstName: campi.firstName.trim(),
        lastName: campi.lastName.trim(),
        role: campi.role.trim() || null,
        officeName: campi.officeName.trim() || null,
      },
      { onSuccess: onChiudi },
    );

  return (
    <Modale
      occhiello={contatto ? 'Modifica contatto' : 'Nuovo contatto'}
      titolo={
        contatto ? `${contatto.firstName} ${contatto.lastName}` : 'Contatto'
      }
      inCorso={salva.isPending}
      onChiudi={onChiudi}
      azioni={
        <>
          <button className="btn btn-ghost" onClick={onChiudi} disabled={salva.isPending}>
            {t('Annulla')}
          </button>
          <span className="spacer" />
          <button className="btn btn-primary" onClick={invia} disabled={salva.isPending}>
            {salva.isPending ? 'Salvo…' : 'Salva contatto'}
          </button>
        </>
      }
    >
      {errore && (
        <div className="avviso" role="alert" style={{ marginBottom: 12 }}>
          <span className="avviso-segno">▲</span>
          <span>{errore.message}</span>
        </div>
      )}

      <div className="fields">
        <CampoBc
          id="c-nome"
          etichetta="Nome"
          obbligatorio
          valore={campi.firstName}
          limite={limiti.contactName}
          onCambia={cambia('firstName')}
        />
        <CampoBc
          id="c-cognome"
          etichetta="Cognome"
          obbligatorio
          valore={campi.lastName}
          limite={limiti.contactName}
          onCambia={cambia('lastName')}
        />
        <CampoBc id="c-ruolo" etichetta="Ruolo" valore={campi.role} onCambia={cambia('role')} />
        <CampoBc
          id="c-ufficio"
          etichetta="Ufficio o sede"
          valore={campi.officeName}
          onCambia={cambia('officeName')}
        />
      </div>
    </Modale>
  );
}
